
var elements = document.getElementsByTagName('a');
var div_;
for(var i = 0, len = elements.length; i < len; i++) {
    if (elements[i].id != 'expand_all') {
      elements[i].onclick = function() {
        div_ = document.getElementById(this.name);
        if (div_){ 
          div_expand = document.getElementById(this.name + "_expand");
          if (div_.classList.contains('hidden')) {
             div_.classList.remove('hidden'); 
             div_.parentElement.parentElement.classList.add('static_open'); 
             if (div_expand){ 
               div_expand.classList.add('expand_close'); 
            }
          }
          else {
             div_.classList.add('hidden'); 
             div_.parentElement.parentElement.classList.remove('static_open'); 
             if (div_expand){ 
               div_expand.classList.remove('expand_close'); 
            }
          }
        }
        if (this.id == 'nolink') {
          Turbolinks.visit('/notes/privacy'); 
        }
        if (this.id == 'nolink2') {
          Turbolinks.visit('/notes/terms'); 
        }
      }
    }
  }

document.addEventListener('load', onFaqLoad()); 

function onFaqLoad() {
  document.getElementById('expand_all').addEventListener('click', function(){expand_all_faq();});
}

  
function expand_all_faq() {
  var elements = document.getElementsByTagName('a');
  var div_;
  for(var i = 0, len = elements.length; i < len; i++) {
    for(var i = 0, len = elements.length; i < len; i++) {
      div_ = document.getElementById(elements[i].name);

      if (div_){ 
        div_.classList.remove('hidden'); 
        div_.parentElement.parentElement.classList.add('static_open'); 
        div_expand = document.getElementById(elements[i].name + "_expand");
        if (div_expand){ 
          div_expand.classList.add('expand_close'); 
        }  
      }
    }
  }
}
 
